import { AreaModel } from "../regions/area";
import { CityModel } from "../regions/city";
import { ServiceTypeModel } from "../services/serviceType";

export interface ServicePartnerModel {
  id: number;
  businessName: string;
  ownerFirstandLastName: string;
  ownerMobileNumber: string;
  ownerEmailId: string;
  defaultCityID: number;
  defaultAreaID: number;
  serviceTypeId: number;
  address: string;
  landmark: string;
  latitude: number;
  longitude: number;
  contactPerson: string;
  contactNumber1: string;
  contactNumber2: string;
  registrationNumber: string;
  preferredPaymentMethod?: string;
  gstNumber: string;
  isActive: boolean;
  referralCode: string;
}

export const ServicePartnerModelObject: ServicePartnerModel = {
  id: 0,
  businessName: '',
  ownerFirstandLastName: '',
  ownerMobileNumber: '',
  defaultCityID: 0,
  defaultAreaID: 0,
  serviceTypeId: 1,
  preferredPaymentMethod: '',
  address: '',
  landmark: '',
  latitude: 0,
  longitude: 0,
  contactPerson: '',
  contactNumber1: '',
  contactNumber2: '',
  ownerEmailId: ' ',
  registrationNumber: '',
  gstNumber: '',
  isActive: true,
  referralCode: '',
};

export interface ServicePartnerGetModel {
  id: number;
  businessName: string;
  ownerFirstandLastName: string;
  ownerMobileNumber: string;
  ownerEmailId: string;
  defaultCity: CityModel;
  defaultArea: AreaModel;
  serviceType: ServiceTypeModel;
  address: string;
  landmark: string;
  geoLocation: {
    latitude: number;
    longitude: number;
  };
  contactPerson: string;
  contactNumber1: string;
  contactNumber2: string;
  registrationNumber: string;
  gstNumber: string;
  isActive: boolean;
  preferredPaymentMethod?: string;
  referralCode: string;
}
